import { HiOutlineMail } from 'react-icons/hi';
import { FaWhatsapp } from 'react-icons/fa';

const data = [
  {
    id: 1,
    icon: <FaWhatsapp />,
    link: 'https://wa.me/18642017069'
  },
  {
    id: 2,
    icon: <HiOutlineMail />,
    link: 'mailto:nguyenlenguyen.1042006@gmail.com'
  }
];

export default data;